// extracted by mini-css-extract-plugin
module.exports = {"root":"VIP_ProductCardActionsIcon__root","counts":"VIP_ProductCardActionsIcon__counts"};